import tealium, { ActionType } from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

export const pageViews = {
  selectStoredata: ActionType.VIEW,
  appointmentBooked: ActionType.VIEW,
};

const defaultData: IDataLayer = {
  selectStoredata: {
    page_name: null,
    page_url: null,
    location: null,
    platform: 'modernized',
  },

  selectedService: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'appointment type chosen',
    event_label: null,
  },

  selectDateTime: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'date and time selected',
    event_label: null,
  },

  appointmentBooked: {
    page_name: null,
    page_url: null,
    location: null,
  },

  addtocalendar: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'completion page interaction',
    event_label: 'add_to_calendar',
  },

  appointmentedit: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'review',
    event_label: 'edit',
  },

  continueShopping: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'completion page interaction',
    event_label: 'continue_shopping',
  },

  cancelandstart: {
    event_name: 'appointment booking',
    event_category: 'appointment booking',
    event_action: 'review',
    event_label: 'cancel and start over',
  },
};

function trackOabStoreSelect(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};
  if (eventData) {
    if (eventData?.step_number) {
      eventData.page_name = 'Book Appointment -' + eventData.step_number;
      eventData.page_url =
        window.location.pathname + '/' + eventData.step_number;
      eventData.location =
        window.location.origin +
        window.location.pathname +
        '/' +
        eventData.step_number;
      tealium.dataLayer.update(eventData);
      tealium.evtView({
        ...data,
        ...defaultData['selectStoredata'],
        ...eventData,
      });
    }
  }
}

function trackOabStoreService(_: string, eventData: IDataLayer = {}) {
  if (eventData) {
    if (eventData?.serviceType) {
      eventData.event_label = eventData.serviceType;
      tealium.dataLayer.update(eventData);
      tealium.evtLink({
        ...defaultData['selectedService'],
        ...eventData,
      });
    }
  }
}

function trackOabSelectDateTime(_: string, eventData: IDataLayer = {}) {
  if (eventData) {
    if (eventData?.date_time) {
      eventData.event_label = eventData.date_time;
      tealium.dataLayer.update(eventData);
      tealium.evtLink({
        ...defaultData['selectDateTime'],
        ...eventData,
      });
    }
  }
}

function trackOabAppointmentBooked(_: string, eventData: IDataLayer = {}) {
  eventData.page_url = '/book-appointment/complete';
  (eventData.location =
    window.location.origin + window.location.pathname + '/complete'),
    (eventData.page_name = 'Book Appointment - Complete');
  tealium.dataLayer.update(eventData);
  tealium.evtView({
    ...defaultData['appointmentbooked'],
    ...eventData,
  });
}

function trackOabAddToCalendar(_: string, eventData: IDataLayer = {}) {
  tealium.dataLayer.update(eventData);
  tealium.evtLink({
    ...defaultData['addtocalendar'],
    ...eventData,
  });
}

function trackOabAppointmentCancel(_: string, eventData: IDataLayer = {}) {
  tealium.dataLayer.update(eventData);
  tealium.evtLink({
    ...defaultData['cancelandstart'],
    ...eventData,
  });
}

function trackOabAppointmentEdit(_: string, eventData: IDataLayer = {}) {
  tealium.dataLayer.update(eventData);
  tealium.evtLink({
    ...defaultData['appointmentedit'],
    ...eventData,
  });
}

function trackOabContinueShopping(_: string, eventData: IDataLayer = {}) {
  tealium.evtLink({
    ...defaultData['continueShopping'],
    ...eventData,
  });
}

// Registering event handlers directly
registerAnalyticsEventHandler('SelectStore', trackOabStoreSelect);
registerAnalyticsEventHandler('SelectService', trackOabStoreService);
registerAnalyticsEventHandler('SelectDateTime', trackOabSelectDateTime);
registerAnalyticsEventHandler('appointmentBooked', trackOabAppointmentBooked);
registerAnalyticsEventHandler('addtocalendar', trackOabAddToCalendar);
registerAnalyticsEventHandler('cancelandstart', trackOabAppointmentCancel);
registerAnalyticsEventHandler('appointmentedit', trackOabAppointmentEdit);
registerAnalyticsEventHandler('continueShopping', trackOabContinueShopping);
